
// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCv1WxtiJP4ODQ_87UNm4OJGzQjo3U3NXM",
  authDomain: "coinfolio-a4fdc.firebaseapp.com",
  projectId: "coinfolio-a4fdc",
  storageBucket: "coinfolio-a4fdc.appspot.com",
  messagingSenderId: "922711688807",
  appId: "1:922711688807:web:0c6cbe2568238783b236c2"
};

export default firebaseConfig;